import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type PartnerSocietySharesOffersProps = {
  hasBuySharesEnabled: boolean;
  hasSellSharesEnabled: boolean;
  isReadOnly: boolean;
  isReadOnlyUser: boolean;
  handleOpenBuyShares: () => void;
  handleOpenSellShares: () => void;
};

const TEMPORARY_DISABLED = false;

const PartnerSocietySharesOffers: FC<PartnerSocietySharesOffersProps> = ({
  hasBuySharesEnabled,
  hasSellSharesEnabled,
  isReadOnly,
  isReadOnlyUser,
  handleOpenBuyShares,
  handleOpenSellShares,
}) => {
  const { t } = useTranslate();

  if (!hasBuySharesEnabled && !hasSellSharesEnabled) {
    return null;
  }

  if (TEMPORARY_DISABLED) {
    return null;
  }

  return (
    <div className="card-inner card-inner-sm px-0">
      <ul className="btn-toolbar justify-center gx-1">
        {hasBuySharesEnabled && (
          <li>
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handleOpenBuyShares}
              disabled={isReadOnly || isReadOnlyUser}
            >
              <em className="icon ni ni-coins mr-1" />
              {t('ToBuy')}
            </button>
          </li>
        )}

        {hasSellSharesEnabled && (
          <li>
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handleOpenSellShares}
              disabled={isReadOnly || isReadOnlyUser}
            >
              <em className="icon ni ni-coins mr-1" />
              {t('ToSell')}
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default PartnerSocietySharesOffers;
